import { useState, useRef, useEffect } from "react";

export function useComponentWidth() {
  const [width, setWidth] = useState<number>(0);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const setWidthFromEl = () => {
      if (ref.current) setWidth(ref.current.offsetWidth);
    };
    setWidthFromEl();
    const observer = new ResizeObserver(setWidthFromEl);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return { width, ref, onLayout: () => {} };
}
